
import BestGallery from './components/BestGallery';

export default {
  i18nComponentKey: 'WidgetReviewsBestGallery.WidgetReviewsBestGalleryMobile',
  name: 'WidgetReviewsBestGalleryMobile',
  components: { BestGallery }
};
